module.exports = __webpack_public_path__ + "media/images/help/flow/eyecatch-pc-99d3155c510c861efb40b5871f17aed6.svg";